export const LinkIcon = () => (
  <svg width="160" height="88" viewBox="0 0 160 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7_368)">
      <g opacity="0.84">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M139.583 14.4069C142.655 14.4069 145.145 16.8967 145.145 19.968C145.145 23.0394 142.655 25.5292 139.583 25.5292H107.806C110.877 25.5292 113.367 28.019 113.367 31.0903C113.367 34.1616 110.877 36.6514 107.806 36.6514H125.283C128.355 36.6514 130.845 39.1412 130.845 42.2125C130.845 45.2838 128.355 47.7736 125.283 47.7736H117.201C113.328 47.7736 110.189 50.2634 110.189 53.3347C110.189 54.5054 110.708 55.6126 111.747 56.6565C113.567 58.4852 116.602 58.5506 118.564 60.2255C119.759 61.2455 120.517 62.7627 120.517 64.4569C120.517 67.5283 118.027 70.0181 114.956 70.0181H49.0167C45.9454 70.0181 43.4556 67.5283 43.4556 64.4569C43.4556 61.3856 45.9454 58.8958 49.0167 58.8958H18.0334C14.9621 58.8958 12.4723 56.406 12.4723 53.3347C12.4723 50.2634 14.9621 47.7736 18.0334 47.7736H49.8112C52.8825 47.7736 55.3723 45.2838 55.3723 42.2125C55.3723 39.1412 52.8825 36.6514 49.8112 36.6514H29.9501C26.8788 36.6514 24.389 34.1616 24.389 31.0903C24.389 28.019 26.8788 25.5292 29.9501 25.5292H61.7279C58.6565 25.5292 56.1667 23.0394 56.1667 19.968C56.1667 16.8967 58.6565 14.4069 61.7279 14.4069H139.583ZM139.583 36.6514C142.655 36.6514 145.145 39.1412 145.145 42.2125C145.145 45.2838 142.655 47.7736 139.583 47.7736C136.512 47.7736 134.022 45.2838 134.022 42.2125C134.022 39.1412 136.512 36.6514 139.583 36.6514Z"
          fill="#D9D8FF"
          fillOpacity="0.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.0546 42.3195C75.781 37.0459 75.781 28.4165 81.0546 23.1428L92.2419 11.9555C97.5155 6.68192 106.145 6.68192 111.419 11.9555C116.692 17.2291 116.692 25.8586 111.419 31.1334L100.231 42.3195C94.9576 47.5931 86.3282 47.5931 81.0546 42.3195Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.1614 42.3195C72.8878 37.0459 72.8878 28.4165 78.1614 23.1428L89.3487 11.9555C94.6223 6.68192 103.252 6.68192 108.525 11.9555C113.799 17.2291 113.799 25.8586 108.525 31.1334L97.3381 42.3195C92.0644 47.5931 83.435 47.5931 78.1614 42.3195Z"
          fill="#D9D8FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.2876 42.3195C73.014 37.0459 73.014 28.4165 78.2876 23.1428L89.4749 11.9555C94.7485 6.68192 99.9778 6.68192 105.251 11.9555C110.526 17.2291 110.526 25.8586 105.251 31.1334L94.0653 42.3195C88.7917 47.5931 83.5612 47.5931 78.2876 42.3195Z"
          fill="#F0F0FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M108.965 11.9555C111.829 14.8193 113.124 18.6721 112.878 22.4399C112.671 20.0398 111.375 17.6386 108.965 15.2287C103.691 9.95511 95.062 9.95511 89.7884 15.2287L78.601 26.416C76.1912 28.8259 74.895 31.2272 74.6878 33.6272C74.4423 29.8594 75.7373 26.0066 78.601 23.1428L89.7884 11.9555C95.062 6.68192 103.691 6.68192 108.965 11.9555Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.1192 45.6809C72.8456 40.4073 64.2162 40.4073 58.9426 45.6809L47.7553 56.8682C42.4816 62.1418 42.4816 70.7713 47.7553 76.0449C53.0289 81.3185 61.6583 81.3185 66.9319 76.0449L78.1192 64.8588C83.3928 59.584 83.3928 50.9545 78.1192 45.6809Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.1192 42.7884C72.8456 37.5148 64.2162 37.5148 58.9426 42.7884L56.5685 45.1613C57.0692 45.8384 56.8595 46.9829 55.9518 47.2555C56.0887 47.5823 56.0887 47.9708 55.863 48.3704C54.9923 49.912 53.8108 51.1848 52.4172 52.2639C51.9127 52.6537 51.2763 52.7634 50.7448 52.407C50.5364 52.7264 50.1997 52.9632 49.7002 52.9632C49.4079 52.9632 49.1834 52.867 48.991 52.7388L47.7553 53.9758C42.4816 59.2494 42.4816 67.8788 47.7553 73.1524C53.0289 78.426 61.6583 78.426 66.9319 73.1524L78.1192 61.9663C83.3928 56.6915 83.3928 48.0621 78.1192 42.7884Z"
          fill="#D9D8FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.1192 42.915C72.8456 37.6414 64.2162 37.6414 58.9426 42.915L56.4106 45.4457C56.8595 46.2326 56.5105 47.4906 55.3278 47.4906C55.2945 47.4906 55.2735 47.4745 55.2427 47.4733C55.4634 48.0752 55.2155 48.7115 54.6901 49.0815C53.6566 49.8067 53.0535 51.0585 52.1853 51.9551C51.7931 52.3609 51.3294 52.4226 50.9224 52.2894C50.7177 52.6298 50.3748 52.8863 49.8543 52.8863C49.5768 52.8863 49.361 52.7999 49.1736 52.6828L47.7553 54.1011C43.398 58.4584 43.398 65.5227 47.7553 69.8788C53.0289 75.1524 61.6583 75.1524 66.9319 69.8788L78.1192 58.6927C82.4765 54.3354 82.4765 47.271 78.1192 42.915Z"
          fill="#F0F0FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.7553 73.5916C50.619 76.4553 54.4718 77.7503 58.2396 77.5048C55.8396 77.2976 53.4383 76.0014 51.0285 73.5916C45.7548 68.3179 45.7548 59.6885 51.0285 54.4137L62.2158 43.2276C64.6256 40.8177 67.0269 39.5215 69.4269 39.3143C65.6579 39.0689 61.8063 40.3638 58.9426 43.2276L47.7553 54.4137C42.4816 59.6885 42.4816 68.3179 47.7553 73.5916Z"
          fill="white"
        />
        <path
          d="M103.041 36.617L97.3392 42.3198C92.0656 47.5922 83.4349 47.5922 78.1613 42.3198C72.8877 37.0462 72.8877 28.4155 78.1613 23.1419L89.3486 11.9546C94.6222 6.68223 103.252 6.68223 108.525 11.9546C113.056 16.4858 113.694 23.4934 110.441 28.7226"
          stroke="#7B79FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M56.3043 45L58.9843 42.32C64.2579 37.0464 72.8874 37.0464 78.161 42.32C83.4346 47.5936 83.4346 56.2243 78.161 61.4979L66.9749 72.684C61.7013 77.9576 53.0706 77.9576 47.797 72.684C42.5234 67.4104 42.5234 58.7809 47.797 53.5061L48.9045 52.3998"
          stroke="#7B79FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M89.6695 30.8114L66.6536 53.8274"
          stroke="#7B79FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.7086 48.6992C53.7086 49.3799 53.156 49.9325 52.4752 49.9325C51.7945 49.9325 51.2419 49.3799 51.2419 48.6992C51.2419 48.0184 51.7945 47.4659 52.4752 47.4659C53.156 47.4659 53.7086 48.0184 53.7086 48.6992Z"
          fill="#7B79FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.974 32.6662C107.974 33.3469 107.421 33.8995 106.741 33.8995C106.06 33.8995 105.507 33.3469 105.507 32.6662C105.507 31.9854 106.06 31.4328 106.741 31.4328C107.421 31.4328 107.974 31.9854 107.974 32.6662Z"
          fill="#7B79FF"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7_368">
        <rect width="158.4" height="88" fill="white" transform="translate(0.800049)" />
      </clipPath>
    </defs>
  </svg>
);
